import { useMemo } from "react"

import { getVariantKeyPrefixLength } from "shared/lib/variant-key/getVariantKeyPrefixLength"
import { InstallationReference } from "shared/types/InstallationReference"

import { InstallationReferenceFilterState } from "../types/InstallationReferenceFilterState"

interface UseInstallationReferenceFilterArgs {
  installationReferences: InstallationReference[] | undefined
  filters: InstallationReferenceFilterState | null | undefined
}

function isEmptyOrIncluded<T extends string>(
  value: T[] | null | undefined,
  array: T[] | null | undefined
) {
  return !array || array.length === 0 || array.some(v => value?.includes(v))
}

function isEmptyOrIncludedVariantKey(
  value: string | null | undefined,
  array: string[] | null | undefined
) {
  const attributes = value?.split("-") || []
  return (
    !array ||
    array.length === 0 ||
    array.some(v => getVariantKeyPrefixLength(v.split("-"), attributes) !== -1)
  )
}

function filterInstallationReference(
  filterableInstallationReference: InstallationReference,
  filters: InstallationReferenceFilterState | null | undefined
) {
  return (
    isEmptyOrIncluded(
      filterableInstallationReference.roomType,
      filters?.roomTypes
    ) &&
    isEmptyOrIncluded(
      filterableInstallationReference.buildingType,
      filters?.buildingTypes
    ) &&
    isEmptyOrIncludedVariantKey(
      filterableInstallationReference.variantKey,
      filters?.products
    )
  )
}

export function useInstallationReferenceFilter({
  installationReferences,
  filters
}: UseInstallationReferenceFilterArgs) {
  return useMemo(
    () =>
      installationReferences?.filter(reference =>
        filterInstallationReference(reference, filters)
      ),
    [installationReferences, filters]
  )
}
